export const DISCARD_EDITS_DIALOG_TITLE = "Discard edits";
export const DISCARD_EDITS_DIALOG_MESSAGE = `Are you sure you want to continue without saving? Any changes you’ve made won’t be saved.`;
